import { graphql, Link } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { BlogLink, PageLayout } from "../components"
import { SEO, Utils } from "../utils"

export default ({ data }) => {
  const { firstName, lastName, occupation, bio } = data.site.siteMetadata

  const allFeaturedImages = data.allFile.edges || []
  const allPosts = data.allMarkdownRemark.edges || []
  const regex = /\/[blog].*\/|$/
  const featuredImageMap = Utils.getImageMap(allFeaturedImages, regex)

  return (
    <PageLayout pageName="page-accueil">
      <SEO title="Accueil" />
      <Container
        fluid
        className="container-home"
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 className="name">
          <span className="logo">
            {lastName} {firstName}
          </span>
        </h1>
        <h4 className="occupation">
          <i>{occupation}.</i>
        </h4>
        <p className="d-flex">
          <Link
            as={Link}
            to="/bio"
            className="button-cv button-pulse mr-4"
          >
            {bio}
          </Link>
        </p>
      </Container>
      <Container
        fluid
        className="p-3 w-auto text-left d-flex flex-wrap justify-content-center"
      >
        <Row>
          <Col md="8 offset-md-2">
            {allPosts.map(({ node }) => (
              <div key={node.id} className="p-3">
                <BlogLink
                  date={node.frontmatter.date}
                  to={node.fields.slug}
                  featuredImage={featuredImageMap[node.fields.slug]}
                  title={node.frontmatter.title}
                  subtitle={node.frontmatter.date}
                  excerpt={node.excerpt}
                  tags={node.frontmatter.tags}
                  time={node.frontmatter.read_time}
                />
              </div>
            ))}
          </Col>
          <Col className="d-flex justify-content-center mt-2" md="8 offset-md-2">
            <Link to="/blog" className="button-article mt-4">
              Consulter plus d'articles →
            </Link>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        unemployed
        firstName
        lastName
        occupation
        bio
      }
    }
    allMarkdownRemark(
      limit: 3
      filter: { fileAbsolutePath: { regex: "/blog/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            description
            tags
            author
            date(formatString: "DD MMMM, YYYY")
            read_time
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
    allFile(
      filter: {
        extension: { eq: "jpg" }
        relativePath: { regex: "/feature/" }
        relativeDirectory: { regex: "/content/blog/" }
      }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid
            }
          }
          relativePath
        }
      }
    }
  }
`
